import { useEffect, useState } from "react";
import API from "../services/api";

export default function AttendanceHistory() {

    const today = new Date()
        .toISOString()
        .split("T")[0];

    const [attendance, setAttendance] = useState([]);

    const [search, setSearch] = useState("");

    const [classFilter, setClassFilter] = useState("");

    const [sectionFilter, setSectionFilter] = useState("");

    const [dateFilter, setDateFilter] = useState("");

    const [showSuggestions, setShowSuggestions] = useState(false);

    const [selectedStudent, setSelectedStudent] = useState(null);

    useEffect(() => {
        fetchAttendance();
    }, []);

    /* =========================
       FETCH ATTENDANCE
    ========================= */

    const fetchAttendance = async () => {

        try {

            const res = await API.get(
                "/attendance/history"
            );

            setAttendance(res.data);

        } catch (err) {

            alert(
                "Unable to load attendance history"
            );
        }
    };

    /* =========================
       DYNAMIC SEARCH SUGGESTIONS
    ========================= */

    const suggestions =

        search.trim() === ""

            ? []

            : attendance
                .filter((item) =>

                    (item.student_name || "")
                        .toLowerCase()
                        .includes(search.toLowerCase())

                    ||

                    (item.admission_no || "")
                        .toLowerCase()
                        .includes(search.toLowerCase())

                )

                .slice(0, 8);

    /* =========================
       FILTER ATTENDANCE
    ========================= */

    const filteredAttendance = attendance.filter((item) => {

        const matchesSearch =

            (item.student_name || "")
                .toLowerCase()
                .includes(search.toLowerCase())

            ||

            (item.admission_no || "")
                .toLowerCase()
                .includes(search.toLowerCase());

        const matchesClass =

            classFilter === ""

            ||

            item.class === classFilter;

        const matchesSection =

            sectionFilter === ""

            ||

            (item.section || "").toUpperCase() ===
            sectionFilter.toUpperCase();

        const itemDate = new Date(item.date)
            .toLocaleDateString("en-CA");

        const matchesDate =

            dateFilter === ""

            ||

            itemDate === dateFilter;

        const matchesSelectedStudent =

            !selectedStudent

            ||

            item.student_id === selectedStudent.student_id;

        return (

            matchesSearch
            &&
            matchesClass
            &&
            matchesSection
            &&
            matchesDate
            &&
            matchesSelectedStudent
        );
    });

 

    /* =========================
       KPI COUNTS
    ========================= */

    const presentCount = filteredAttendance.filter(
        (item) => item.status === "Present"
    ).length;

    const absentCount = filteredAttendance.filter(
        (item) => item.status === "Absent"
    ).length;

    const attendancePercentage =

        filteredAttendance.length > 0

            ? (
                (
                    presentCount
                    /
                    filteredAttendance.length
                ) * 100
            ).toFixed(1)

            : 0;

    return (

        <div className="p-3 sm:p-4 lg:p-6 bg-gradient-to-br from-gray-100 to-blue-50 min-h-screen">

            {/* HEADER */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6 lg:mb-8">

                <div>

                    <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
                        Attendance History
                    </h1>

                    <p className="text-gray-500 mt-2">
                        Smart ERP Attendance Analytics
                    </p>

                </div>

            </div>

            {/* KPI CARDS */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 mb-6 lg:mb-8">

                <div className="bg-white rounded-3xl shadow-xl p-4 sm:p-6">

                    <p className="text-gray-500 text-sm">
                        Total Records
                    </p>

                    <h2 className="text-2xl sm:text-4xl font-bold text-blue-700 mt-2">
                        {filteredAttendance.length}
                    </h2>

                </div>

                <div className="bg-white rounded-3xl shadow-xl p-4 sm:p-6">

                    <p className="text-gray-500 text-sm">
                        Present
                    </p>

                    <h2 className="text-2xl sm:text-4xl font-bold text-green-700 mt-2">
                        {presentCount}
                    </h2>

                </div>

                <div className="bg-white rounded-3xl shadow-xl p-4 sm:p-6">

                    <p className="text-gray-500 text-sm">
                        Absent
                    </p>

                    <h2 className="text-2xl sm:text-4xl font-bold text-red-700 mt-2">
                        {absentCount}
                    </h2>

                </div>

                <div className="bg-white rounded-3xl shadow-xl p-4 sm:p-6">

                    <p className="text-gray-500 text-sm">
                        Attendance %
                    </p>

                    <h2 className="text-2xl sm:text-4xl font-bold text-purple-700 mt-2">
                        {attendancePercentage}%
                    </h2>

                </div>

            </div>

            {/* FILTER PANEL */}
            <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 lg:p-8 mb-6 lg:mb-8">

                <h2 className="text-xl sm:text-2xl font-bold mb-5 sm:mb-6">
                    Search & Filters
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-4 xl:grid-cols-5 gap-5">

                    {/* SEARCH */}
                    <div className="relative">

                        <input
                            type="text"
                            placeholder="Search student or admission no"
                            value={search}
                            onChange={(e) => {

                                setSearch(e.target.value);

                                setSelectedStudent(null);

                                setShowSuggestions(
                                    e.target.value.trim() !== ""
                                );

                            }}
                            className="border rounded-2xl p-4 w-full"
                        />

                        {/* Suggestions */}
                        {showSuggestions && search && (

                            <div className="absolute bg-white border rounded-2xl shadow-2xl w-full mt-2 z-50 max-h-72 overflow-y-auto">

                                {suggestions.length > 0 ? (

                                    suggestions.map((item, index) => (

                                        <div
                                            key={index}
                                            onClick={() => {

                                                setSearch(
                                                    item.student_name
                                                );

                                                setSelectedStudent(item);

                                                setClassFilter(item.class);

                                                setSectionFilter(item.section);

                                                setShowSuggestions(false);
                                            }}
                                            className="p-4 hover:bg-blue-50 cursor-pointer border-b"
                                        >

                                            <p className="font-bold">
                                                {item.student_name}
                                            </p>

                                            <p className="text-sm text-gray-500">

                                                {item.admission_no}
                                                {" � "}
                                                Class {item.class}
                                                {" "}
                                                Section {item.section}

                                            </p>

                                        </div>

                                    ))

                                ) : (

                                    <div className="p-4 text-gray-500">
                                        No students found
                                    </div>

                                )}

                            </div>
                        )}

                    </div>

                    {/* CLASS */}
                    <select
                        value={classFilter}
                        onChange={(e) =>
                            setClassFilter(e.target.value)
                        }
                        className="border rounded-2xl p-4"
                    >

                        <option value="">
                            All Classes
                        </option>

                        {[
                            "PP1",
                            "PP2",
                            "LKG",
                            "UKG",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12"
                        ].map((cls) => (

                            <option
                                key={cls}
                                value={cls}
                            >
                                {cls}
                            </option>
                        ))}

                    </select>

                    {/* SECTION */}
                    <select
                        value={sectionFilter}
                        onChange={(e) =>
                            setSectionFilter(e.target.value)
                        }
                        className="border rounded-2xl p-4"
                    >

                        <option value="">
                            All Sections
                        </option>

                        {"ABCDEFGHIJKLMNOPQRSTUVWXYZ"
                            .split("")
                            .map((letter) => (

                                <option
                                    key={letter}
                                    value={letter}
                                >
                                    {letter}
                                </option>
                            ))}

                    </select>

                    {/* DATE */}
                    <input
                        type="date"
                        value={dateFilter}
                        onChange={(e) =>
                            setDateFilter(e.target.value)
                        }
                        className="border rounded-2xl p-4"
                    />

                    {/* SEARCH BUTTON */}
                    {/*<button*/}
                    {/*    onClick={() => {*/}

                    {/*        setShowSuggestions(false);*/}
                    {/*    }}*/}
                    {/*    className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-3 rounded-2xl font-bold"*/}
                    {/*>*/}
                    {/*    Search Attendance*/}
                    {/*</button>*/}

                </div>

            </div>

            {/* TABLE */}
            <div className="bg-white rounded-3xl shadow-2xl p-4 sm:p-6 lg:p-8">

                <div className="hidden md:block overflow-x-auto">

                    <table className="w-full">

                        <thead>

                            <tr className="bg-blue-50">

                                <th className="p-5 text-left">
                                    Date
                                </th>

                                <th className="p-5 text-left">
                                    Admission No
                                </th>

                                <th className="p-5 text-left">
                                    Student Name
                                </th>

                                <th className="p-5 text-left">
                                    Class
                                </th>

                                <th className="p-5 text-left">
                                    Section
                                </th>

                                <th className="p-5 text-left">
                                    Status
                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            {filteredAttendance.map((item) => (

                                <tr
                                    key={item.id}
                                    className="border-b hover:bg-gray-50"
                                >

                                    <td className="p-5">

                                        {
                                            new Date(
                                                item.date
                                            ).toLocaleDateString("en-GB")
                                        }

                                    </td>

                                    <td className="p-5 font-bold text-blue-700">
                                        {item.admission_no}
                                    </td>

                                    <td className="p-5">
                                        {item.student_name}
                                    </td>

                                    <td className="p-5">
                                        {item.class}
                                    </td>

                                    <td className="p-5">
                                        {item.section}
                                    </td>

                                    <td className="p-5">

                                        <span
                                            className={`px-4 py-2 rounded-2xl font-bold text-sm ${item.status === "Present"

                                                    ? "bg-green-100 text-green-700"

                                                    : "bg-red-100 text-red-700"
                                                }`}
                                        >

                                            {item.status}

                                        </span>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

                {/* MOBILE ATTENDANCE HISTORY */}
                <div className="md:hidden space-y-4">

                    {filteredAttendance.length > 0 ? (

                        filteredAttendance.map((item) => {

                            const isPresent = item.status === "Present";

                            return (
                                <div
                                    key={item.id}
                                    className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4"
                                >

                                    {/* TOP ROW */}
                                    <div className="flex justify-between items-start gap-3 mb-4">

                                        <div>
                                            <p className="text-xs font-semibold text-gray-500 uppercase">
                                                Date
                                            </p>

                                            <p className="text-base font-bold text-gray-800">
                                                {new Date(
                                                    item.date
                                                ).toLocaleDateString("en-GB")}
                                            </p>
                                        </div>

                                        <span
                                            className={`px-3 py-1.5 rounded-full text-xs font-bold ${isPresent
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-red-100 text-red-700"
                                                }`}
                                        >
                                            {isPresent ? "PRESENT" : "ABSENT"}
                                        </span>

                                    </div>


                                    {/* STUDENT */}
                                    <div className="mb-4">

                                        <p className="text-xs font-semibold text-gray-500 uppercase">
                                            Student
                                        </p>

                                        <p className="text-lg font-bold text-gray-800 break-words">
                                            {item.student_name}
                                        </p>

                                    </div>


                                    {/* ADMISSION NUMBER */}
                                    <div className="mb-4">

                                        <p className="text-xs font-semibold text-gray-500 uppercase">
                                            Admission No
                                        </p>

                                        <p className="text-base font-bold text-blue-700">
                                            {item.admission_no}
                                        </p>

                                    </div>


                                    {/* CLASS / SECTION */}
                                    <div className="grid grid-cols-2 gap-3">

                                        <div className="bg-gray-50 rounded-xl p-3">

                                            <p className="text-xs font-semibold text-gray-500">
                                                Class
                                            </p>

                                            <p className="text-base font-bold text-gray-800">
                                                {item.class}
                                            </p>

                                        </div>


                                        <div className="bg-gray-50 rounded-xl p-3">

                                            <p className="text-xs font-semibold text-gray-500">
                                                Section
                                            </p>

                                            <p className="text-base font-bold text-gray-800">
                                                {item.section}
                                            </p>

                                        </div>

                                    </div>

                                </div>
                            );

                        })

                    ) : (

                        <div className="bg-white rounded-2xl border p-6 text-center">

                            <p className="text-gray-500 font-semibold">
                                No attendance records found
                            </p>

                        </div>

                    )}

                </div>


            </div>

        </div>


    );
}